import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import ThumbnailsColumn from '../../../../components/Editor/Thumbnails/Column';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			thumbnails: { isDisplayed, width },
			pagesController: { currentSpreadIndex, spreads, accessiblePages },
			activeItem,
			pagesSelection: { isActive, spreadIndices },
			isAccessibleVersion,
		},
	} = state;

	return {
		isDisplayed,
		width,
		currentSpreadIndex,
		spreads,
		isSomeEditableItemActive: !!activeItem.id,
		isPagesSelectionActive: isActive,
		selectedSpreadIndices: spreadIndices,
		accessiblePages,
		isAccessibleVersion,
	};
};

export default connect(mapStateToProps)(ThumbnailsColumn);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Thumbnails/Column/index.tsx